require("slick-carousel")

class window.AdvantagesSlider
  constructor: ()->
    @initSlider()

  initSlider: ->
    $('.advantages-slider--top').slick({
      prevArrow: $('.advantages-slider__arrow-back')
      nextArrow: $('.advantages-slider__arrow-next')
      arrows: true,
      dots: true,
      infinite: false,
      initialSlide: 0,
      swipeToSlide: true,
      focusOnSelect: true,
      variableWidth: false,
      appendDots: ".slick-track",
      asNavFor: '.advantages-slider--bottom-container'
    })

    $('.advantages-slider--bottom-container').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      variableWidth: false,
      asNavFor: '.advantages-slider--top',
      focusOnSelect: true,
      speed: 800
    })



// WEBPACK FOOTER //
// ./assets/javascripts/app/advantages_slider.coffee